import { trackPromise } from 'react-promise-tracker';
import api from '../../../../utils/API';
import type { ElasticityFilterRequest, ElasticitySelectionResponse, PageElasticitySelectionResponse, SegmentListResponse } from './types';

const BASE_URL = process.env.REACT_APP_IND_CROSS_ELASTICITY_SETUP_URL;

export const getSegments = (filters: ElasticityFilterRequest) =>
  trackPromise(
    api({
      url: `${BASE_URL}/segments`,
      method: 'POST',
      data: filters,
      expectToken: true,
    }).then(resp => resp.data as SegmentListResponse[]),
    'elasticidade-segments',
  );

export const getRegions = (filters: ElasticityFilterRequest) =>
  trackPromise(
    api({
      url: `${BASE_URL}/regions`,
      method: 'POST',
      data: filters,
      expectToken: true,
    }).then(resp => resp.data as string[]),
    'elasticidade-regions',
  );

export const getElasticitySelection = (gtin: string) =>
  trackPromise(
    api({
      url: `${BASE_URL}/elasticity-selections`,
      method: 'GET',
      params: { gtin },
      expectToken: true,
    }).then(resp => resp.data as ElasticitySelectionResponse),
    'elasticidade-selection',
  );

export const getElasticitySelectionsPaged = (page = 0, size = 50) =>
  trackPromise(
    api({
      url: `${BASE_URL}/elasticity-selections/paged`,
      method: 'GET',
      params: { page, size },
      expectToken: true,
    }).then(resp => resp.data as PageElasticitySelectionResponse),
    'elasticidade-selections-paged',
  );
